import subcategorySymbols from "../symbols/subcategories";
import {
  HttpRegularDelete,
  HttpRegularPost,
  HttpRegularPut,
  HttpRequestPost,
} from "../../service";
const subcategorysSymbolsAction = () => ({
  type: subcategorySymbols.GET_SUBCATEGORIES,
});
const subcategorysSymbolsSuccessAction = (data: any) => ({
  type: subcategorySymbols.GET_SUBCATEGORIES_SUCCESS,
  payload: data,
});
const subcategorysSymbolsFailureAction = (data: any) => ({
  type: subcategorySymbols.GET_SUBCATEGORIES_FAILURE,
  payload: data,
});

const subcategorysSymbolsClearAction = () => ({
  type: subcategorySymbols.CLEAR_GET_SUBCATEGORIES,
});

export function getSubcategoriesSymbols() {
  return (dispatch: any) => {
    dispatch(subcategorysSymbolsAction());
    HttpRequestPost(
      "/upc/subcategory/list",
      dispatch,
      subcategorysSymbolsSuccessAction,
      subcategorysSymbolsFailureAction,
      true,
      { Query: "", OrderBy: "Asc" }
    );
  };
}

export function getSubcategoriesSymbolsWithParams(
  Query: string,
  OrderBy?: string | null,
  Filter?: { Verticals: Array<string>; Categories: Array<string> } | null
) {
  return (dispatch: any) => {
    dispatch(subcategorysSymbolsAction());
    HttpRequestPost(
      `/upc/subcategory/list`,
      dispatch,
      subcategorysSymbolsSuccessAction,
      subcategorysSymbolsFailureAction,
      true,
      Filter ? { OrderBy, Query, Filter } : { OrderBy, Query }
    );
  };
}

export function addNewSubcategory(body: any, failAction?: any, callback?: any) {
  return (dispatch: any) => {
    HttpRegularPost("/upc/subcategory", body, {
      dispatch: dispatch,
      actionSuccess: getSubcategoriesSymbols,
      actionFailure: failAction,
      callback: callback,
    });
  };
}

export function deleteSubcategory(id: any, failAction?: any, callback?: any) {
  return (dispatch: any) => {
    HttpRegularDelete("/upc/subcategory/" + id, {
      dispatch: dispatch,
      actionFailure: failAction,
      callback: callback,
    });
  };
}

export function updateSubcategory(
  id: string,
  body: any,
  failAction?: any,
  callback?: any
) {
  return (dispatch: any) => {
    HttpRegularPut("/upc/subcategory/" + id, body, {
      dispatch: dispatch,
      actionSuccess: getSubcategoriesSymbols,
      actionFailure: failAction,
      callback: callback,
    });
  };
}

export function clearSubCategorysSymbols() {
  return (dispatch: any) => {
    dispatch(subcategorysSymbolsClearAction());
  };
}
